import { SITE_ORIGIN, getPublicRoute, isPubliclyLive } from '@/lib/analytics/publicRoutes';
import { webPageStructuredDataGraph } from '@/lib/webPageStructuredData';

// Breadcrumb and page records for /buy/pre-approval. This module ships in the
// main bundle (RouteMetadata keeps the schema current on SPA navigation), so
// it imports only shared schema/route helpers — never guide copy or styles.

const PATH = '/buy/pre-approval';

export const PREAPPROVAL_SCHEMA_ID = 'lw-preapproval-schema';

/** The visible breadcrumb and the BreadcrumbList both render from this list. */
export const PREAPPROVAL_CRUMBS = [
  { name: 'Home', path: '/' },
  { name: 'Resources', path: '/resources' },
  { name: 'Mortgage pre-approval', path: PATH },
] as const;

/** The page's visible H1 (HERO.productLine; a unit test keeps them equal). */
export const PREAPPROVAL_PAGE_NAME = 'Lendwise READY mortgage pre-approval';

/**
 * The same modest baseline the calculators ship: BreadcrumbList plus WebPage.
 * No FAQ or step-by-step markup: FAQ rich results are retired, and the
 * guide's FAQs and steps stay plain visible content.
 */
export function preapprovalStructuredDataGraph(pathname: string): object | null {
  const route = getPublicRoute(pathname);
  if (!route || route.path !== PATH || !isPubliclyLive(PATH)) return null;
  const url = `${SITE_ORIGIN}${PATH}`;
  return webPageStructuredDataGraph({
    url,
    name: PREAPPROVAL_PAGE_NAME,
    description: route.description,
    crumbs: PREAPPROVAL_CRUMBS.map((crumb) => ({
      name: crumb.name,
      item: `${SITE_ORIGIN}${crumb.path}`,
    })),
  });
}
